import React from 'react';

export const webRootCss = (
  <style type="text/css">{`
    
`}</style>
);
